<router-outlet></router-outlet>
<p-toast position="bottom-right" key="main"></p-toast>
<p-toast styleClass="custom-toast"  position="bottom-right"  key="longTextNotification"></p-toast>
<div class="layout-search notification-message layout-search-active ">
  <div class="search-container fade-in-up message-box-color">
    <h5>Turn Your Device For Better Viewing Experience </h5>
  </div>
</div>

